import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DriversManagementApiService } from '../../../services/drivers-management-api.service';
import { Driver } from '../../../models/driver';
import { GenericPaginationResponseBody } from '../../../../../shared/models/Generic-pagination-response-body';
import { LimitOffsetPagination } from '../../../../../shared/models/limit-offset-pagination';
import { ToastNotificationService } from '../../../../../notifications/services/toast-notification.service';
import { ToastNotificationType } from '../../../../../notifications/models/toast-notification-type';
import { TableSkeletonRowComponent } from '../../../../../shared/components/table-skeleton-row/table-skeleton-row.component';
import { TablePaginationComponent } from '../../../../../shared/components/table-pagination/table-pagination.component';

@Component({
  selector: 'app-driver-management-page',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule, TableSkeletonRowComponent, TablePaginationComponent],
  templateUrl: './driver-management-page.component.html',
})
export class DriverManagementPageComponent implements OnInit {

  private apiService = inject(DriversManagementApiService);
  private toast = inject(ToastNotificationService);
  private translate = inject(TranslateService);

  driversResponse: GenericPaginationResponseBody<Driver> | undefined;
  pagination: LimitOffsetPagination = { limit: 10, offset: 0 };
  search = '';
  private searchTimer: any;

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.driversResponse = undefined;
    this.apiService.getDrivers(this.pagination, this.search).subscribe({
      next: (response) => { this.driversResponse = response; },
      error: () => {
        this.toast.createNotification(this.translate.instant('drivers_management.list.errors.load_failed'), ToastNotificationType.ERROR);
      }
    });
  }

  onSearchChange(event: Event): void {
    this.search = (event.target as HTMLInputElement).value;
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.pagination = { ...this.pagination, offset: 0 };
      this.load();
    }, 350);
  }

  updatePagination(pagination: LimitOffsetPagination): void {
    this.pagination = pagination;
    this.load();
  }
}
